import { isDev } from './isDev';

export function throwInDev(msg: string) {
  if (isDev()) {
    const error = new Error(msg);
    Error.captureStackTrace?.(error, throwInDev);
    throw error;
  } else {
    console.error(msg);
  }
}
